import { useState } from 'react';

import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';

import { FlexiApprovedView } from './FlexiApprovedView/FlexiApprovedView';
import { LoanSummary } from './LoanSummary/LoanSummary';
import { FundingProgressIndicator } from '../FundingProgressIndicator/FundingProgressIndicator';

export const ApprovedView = () => {
    const [selectedOffer, setSelectedOffer] = useState<
        TFormalOffer | undefined
    >();
    const [drawdownAmount, setDrawdownAmount] = useState<number | undefined>();
    const [isSingleOffer, setIsSingleOffer] = useState(false);

    return (
        <div className="flex flex-col bg-structure-100 min-m:flex-row">
            <div className="flex grow basis-0 justify-center min-m:justify-end min-m:px-2xl">
                <div className="w-full max-w-[610px]">
                    <FundingProgressIndicator step={2} />
                    <FlexiApprovedView
                        onSelectedOfferChange={setSelectedOffer}
                        onDrawdownAmountChange={setDrawdownAmount}
                        onIsSingleOfferChange={setIsSingleOffer}
                    />
                </div>
            </div>
            <LoanSummary
                selectedOffer={selectedOffer}
                drawdownAmount={drawdownAmount}
                isSingleOffer={isSingleOffer}
            />
        </div>
    );
};
